import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _, { chain, partial, split } from 'lodash';

import {
    KYC_STATE_DECLINED,
    KYC_STATE_RETRY,
    KYC_STATE_VALIDATED,
    KYC_USE_CASE_DECLINED_PURCHASE,
    KYC_USE_CASE_FAILURE_BANK_TRANSFER
} from '../../../../services/kyc/constants';
import { PATH } from '../../../../constants/path';
import { STATIC_ROOT, CONTEXT_ROOT } from '../../../../constants';
import { MODAL_TYPE_KYC } from '../../../../services/modal/constants';
import { DECLINED_PAYMENT_CODE } from '../../../../services/checkout/constants';

import { resetKyc } from '../../../../services/kyc/actions';
import { showModal } from '../../../../services/modal/actions';
import { fetchIsIdentityVerified } from '../../../../services/account/identity/actions';

import { getPartner } from '../../../../services/partner/selector';

import {
    getLastUserInfoStored,
    isFailureBankTransferEnabled
} from '../../../../utils/storageUtils';
import { getPartnerIdFromQuery } from '../../../../utils';
import { getMerchantCardUrl } from '../../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import Stepper from '../Stepper';
import { Logo } from '../../../icons/Logo';
import HeadComponent from '../../../HeadComponent';
import ButtonComponent from '../../../button/ButtonComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import LinkButtonComponent from '../../../button/LinkButtonComponent';

import './ErrorEbonPage.scss';

const ErrorEbonPage = ({
    i18n,
    BRAND_NAME,
    ebcPartnerId,
    paymentId,
    showModal,
    resetKyc,
    history,
    partner,
    status,
    kycState,
    fetchIsIdentityVerified,
    identityVerified,
    identityVerifiedFetching
}) => {
    const [kycErrorCase, setKycErrorCase] = useState(null);

    const userInfo = getLastUserInfoStored();
    const failureBankTransferEnabled = isFailureBankTransferEnabled();

    useEffect(() => {
        fetchIsIdentityVerified();
    }, []);

    const isKycRequired = () => {
        if (!identityVerified && !failureBankTransferEnabled && status === DECLINED_PAYMENT_CODE) {
            if (!kycErrorCase) setKycErrorCase(KYC_USE_CASE_DECLINED_PURCHASE);
            return true;
        } else if (!identityVerified && failureBankTransferEnabled) {
            if (!kycErrorCase) setKycErrorCase(KYC_USE_CASE_FAILURE_BANK_TRANSFER);
            return true;
        } else {
            return false;
        }
    };

    const showKycModal = () => {
        showModal(MODAL_TYPE_KYC, {
            hideCloseButton: true,
            useCase: kycErrorCase
        });
    };

    useEffect(() => {
        if (kycState === KYC_STATE_VALIDATED) {
            fetchIsIdentityVerified();
            if (kycErrorCase === KYC_USE_CASE_DECLINED_PURCHASE) {
                resetKyc();
                redirectToMerchantCard();
            }
        }
        if (kycState === KYC_STATE_DECLINED || kycState === KYC_STATE_RETRY) {
            if (kycErrorCase === KYC_USE_CASE_FAILURE_BANK_TRANSFER) {
                resetKyc();
                redirectToMerchantCard();
            }
        }
    }, [kycState]);

    const redirectToMerchantCard = () => {
        if (partner && partner.id) {
            const urlFicheMarchand = getMerchantCardUrl(partner, false, true);
            history.push(urlFicheMarchand);
        } else {
            history.push(PATH.HOME_PATH);
        }
    };

    const showBankTransfer =
        !identityVerifiedFetching &&
        failureBankTransferEnabled &&
        !isKycRequired() &&
        paymentId &&
        userInfo &&
        userInfo.phoneNumber;
    const showKyc =
        !identityVerifiedFetching && isKycRequired() && userInfo && userInfo.phoneNumber;

    return (
        <div className="template template-primary flex-container-v">
            <div className="entete hideNav" id="entete">
                <div className="flex-container-v">
                    <header className="tetedepage conteneur flex-container-h flex-center-alt">
                        <LocalizedNavLink to={PATH.HOME_PATH} title={BRAND_NAME} className="logo">
                            <Logo />
                        </LocalizedNavLink>
                        <Stepper steps={i18n.STEPS} current={2} />
                    </header>
                </div>
            </div>

            <main id="p-ebon-error" className="conteneur conteneur-mobile">
                <HeadComponent
                    title={i18n.ERROR.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.EBON_ERROR_PATH}-${ebcPartnerId}`}
                />
                <Stepper steps={i18n.STEPS} current={2} cssClass="mobileDisplay" />
                <div className="error-container">
                    <h1>{i18n.ERROR.TITLE}</h1>

                    <p>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_1)}</p>
                    <div className="reasons">
                        <ul>
                            <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_2)}</li>
                            <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_3)}</li>
                            <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_4)}</li>
                        </ul>
                    </div>
                    <p>{i18n.ERROR.TEXT_5}</p>
                    <p>{i18n.ERROR.TEXT_6}</p>
                    <br />

                    {identityVerifiedFetching ? (
                        <div className="loading">
                            <LoadingComponent />
                        </div>
                    ) : (
                        <React.Fragment>
                            <div className="conteneur-color">
                                <p>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_7)}</p>
                                {showKyc && (
                                    <LinkButtonComponent
                                        to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                                        text={i18n.ERROR.BUTTON_TEXT}
                                        title={i18n.ERROR.BUTTON_TEXT}
                                        color="main"
                                    />
                                )}
                            </div>

                            {(showBankTransfer || showKyc) && <p>{i18n.ERROR.TEXT_OR}</p>}

                            {showBankTransfer && (
                                <div className="conteneur-color">
                                    <p>
                                        {convertHtmlToReactDomWithParams(
                                            i18n.ERROR.TEXT_IBAN_1,
                                            paymentId
                                        )}
                                    </p>
                                    <div className="iban">
                                        <p className="label">{i18n.ERROR.TEXT_IBAN_2}</p>
                                        <p>{i18n.ERROR.TEXT_IBAN_3}</p>
                                        <p className="label">{i18n.ERROR.TEXT_IBAN_4}</p>
                                        <p>{i18n.ERROR.TEXT_IBAN_5}</p>
                                        <p className="small">{i18n.ERROR.TEXT_IBAN_6}</p>
                                        <p className="label">{i18n.ERROR.TEXT_IBAN_7}</p>
                                        <p>
                                            {convertHtmlToReactDomWithParams(
                                                i18n.ERROR.TEXT_IBAN_8
                                            )}
                                        </p>
                                        <p className="info">
                                            {convertHtmlToReactDomWithParams(
                                                i18n.ERROR.TEXT_IBAN_9
                                            )}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {showKyc && (
                                <div className="conteneur-color kyc">
                                    <p>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_KYC_1)}</p>
                                    <ButtonComponent
                                        color="main"
                                        text={i18n.ERROR.TEXT_KYC_BUTTON_TEXT}
                                        onClick={showKycModal}
                                    />

                                    <p className="info">
                                        {convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_KYC_2)}
                                    </p>
                                    <div className="ubble">
                                        <div>{i18n.ERROR.TEXT_KYC_3}</div>
                                        <div>
                                            <img
                                                src={`${STATIC_ROOT}/kyc/ubble.png`}
                                                alt="Ubble logo"
                                                width="100"
                                                height="37"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {!showKyc && (
                                <LinkButtonComponent
                                    to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                                    text={i18n.ERROR.BUTTON_TEXT}
                                    title={i18n.ERROR.BUTTON_TEXT}
                                    color="main"
                                />
                            )}
                        </React.Fragment>
                    )}
                </div>
            </main>
        </div>
    );
};

ErrorEbonPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const ebcPartnerId = getPartnerIdFromQuery(ownProps.match.url);
    const search = ownProps.location.search;
    const params =
        search &&
        chain(search)
            .replace('?', '') // a=toto
            .split('&') // ["a=toto","c=bobo","f=coco"]
            .map(partial(split, _, '=', 2)) // [["a","toto"],["c","bobo"],["f","coco"]]
            .fromPairs() // {"a":"toto","c":"bobo","f":"coco"}
            .value();
    const orderId = params.orderId;
    const paymentId = orderId ? params.orderId.replaceAll('-', '').substr(0, 8) : null;
    const status = params.code;

    const partnerId = ownProps.match.params.id;
    const partner = getPartner(state, partnerId);

    const kycRequired = status === DECLINED_PAYMENT_CODE;

    return {
        i18n: state.i18n.page.EBON,
        ebcPartnerId: ebcPartnerId,
        paymentId: paymentId,
        partner,
        kycRequired: kycRequired,
        kycState: state.kyc.state,
        identityVerified: state.account.identity.verified,
        identityVerifiedFetching: state.account.identity.fetching
    };
};

const mapDispatchToProps = {
    showModal,
    resetKyc,
    fetchIsIdentityVerified
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorEbonPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/ErrorEbonPage.js